/*
 * This module implements a TosRUs media plugin to show iframes in slides.
 *
 * TosRUs already has a generic html media plugin which allows iframes to be
 * inserted, but it's not ideal as it doesn't scale the HTML to fit the
 * available area.
 *
 * This plugins works like the youtube plugin in that the iframe can be given
 * an aspect ratio, and it's given as much space as possible given that aspect
 * ratio.
 */

import $ from 'jquery';

import { tosrus, BaseTosRUsMediaPlugin } from './tosrus';


const MEDIA = 'iframe',
      DEFAULT_OPTIONS = {
          ratio: 16 / 9
      };


export class IFrameTosRUsMediaPlugin extends BaseTosRUsMediaPlugin {

    init() {
        super.init();

        // Define additional constants used by this media plugin
        this.tos.data.add('media ratio');
    }

    filterAnchors(tosInstance, $anchor) {
        return $anchor.data(this.tos.data.media) === MEDIA;
    }

    initAnchors(tosInstance, $slide, href) {
        let $anchor = $slide.data(this.tos.data.anchor);

        $('<iframe>')
            // Allow the iframe's src to be different to the a's href
            .attr('src', $anchor.data('tos-iframe-src') || href)
            .appendTo($slide);

        this.initIframe(tosInstance, $slide);
    }

    initIframe(tosInstance, $slide) {
        let $iframe = $slide.children('iframe');
        let $anchor = $slide.data(this.tos.data.anchor) || $();

        let ratio = $anchor.data(this.tos.data.ratio) ||
                    tosInstance.opts[MEDIA].ratio;

        $slide.removeClass(this.tos.classes.loading)
            .trigger(this.tos.events.loaded)
            .on(this.tos.events.loading,
            () => this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio));

        this.tos.globals.$wndw.on(this.tos.events.resize,
            () => this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio));
    }

    // These two *Slides functions are used when TosRUs is used inline rather
    // than as a modal. We don't do that, so these aren't implemented at the
    // moment.
    filterSlides(tosInstance, $slide) {
        // TODO: implement
        return false;
    }

    initSlides(tosInstance, $slide) {
        throw new Exception('Not implemented');
    }
}

export function register() {
    tosrus.media[MEDIA] = new IFrameTosRUsMediaPlugin();
    tosrus.defaults.media[MEDIA] = {};
    tosrus.defaults[MEDIA] = DEFAULT_OPTIONS;
}



/** WEBPACK FOOTER **
 ** ./js/view/components/lightbox/tosrus.iframe.js
 **/